import { render, staticRenderFns } from "./JsonRenderer.vue?vue&type=template&id=50d8b44f&scoped=true&"
import script from "./JsonRenderer.vue?vue&type=script&lang=js&"
export * from "./JsonRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8b44f",
  null
  
)

export default component.exports